<template>
  <div>
    <v-row>
      <v-col>
        <VAutocomplete
          v-model="data[analysisType].analyticProcedure"
          :label="$t('controlChart.tab1.tableHeader.analyticProcedure')"
          :items="displayAnalyticProcedures"
          :clearable="true"
          @change="updateData"
        />
      </v-col>
      <v-col>
        <v-checkbox
          v-model="data[analysisType].siteControlled"
          :label="$t('controlChart.tab1.tableHeader.siteControlled')"
          @change="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-simple-table
        fixedHeader
        style="max-height: 300px; overflow-y: auto"
      >
        <thead>
          <tr>
            <th>
              {{ $t('controlChart.tab1.tableHeader.action') }}
            </th>
            <th
              v-for="head in actionTableHeads"
              :key="head.action"
              class="text-left"
            >
              {{ $t(`tree.${head.action}`) }}
            </th>
            <th>
              {{ $t('controlChart.tab1.tableHeader.corectiveProcedure') }}
            </th>
            <th />
          </tr>
          <th v-if="actionsLength === 0">
            <v-btn
              icon
              @click="addRow"
            >
              <v-icon>
                add
              </v-icon>
            </v-btn>
            <v-btn
              icon
              @click="removeRow(index)"
            >
              <v-icon>
                remove
              </v-icon>
            </v-btn>
          </th>
        </thead>
        <tbody>
          <tr
            v-for="(action, index) in data[analysisType].actions"
            :key="index"
          >
            <td>
              <VAutocomplete
                v-model="action.chartAction"
                :items="displayActions"
                :clearable="true"
                @change="updateData"
              />
            </td>
            <td
              v-for="(head, headIndex) in actionTableHeads"
              :key="head.action"
            >
              <div v-if="head.label === 'MinMax'" />
              <v-checkbox
                v-else
                v-model="action.norms[head.action]"
                :color="head.color"
                :disabled="isNormDisabled(headIndex, action.norms)"
                @change="updateData"
              />
            </td>
            <td>
              <VAutocomplete
                v-model="action.correctiveProcedure"
                :items="displayCorrectiveProcedures"
                :clearable="true"
                @change="updateData"
              />
            </td>
            <td>
              <v-btn
                icon
                @click="addRow"
              >
                <v-icon>
                  add
                </v-icon>
              </v-btn>
              <v-btn
                icon
                @click="removeRow(index)"
              >
                <v-icon>
                  remove
                </v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';


export default ({
    components: {
        VAutocomplete,
    },
    props: {
        analysis: {
            type: Object,
            default: () => {},
        },
        analysisTypeId: {
            type: String,
            default: '',
        },
        analyticProcedures: {
            type: Array,
            default: () => [],
        },
        correctiveProcedures: {
            type: Array,
            default: () => [],
        },
        chart: {
            type: Object,
            default: () => {},
        },
    },
    data: () => ({
        actions: [],
        data: [],
    }),
    computed: {
        ...mapGetters([
            'userLang',
            'teamMainLang',
        ]),
        actionTableHeads() {
            return [
                { label: 'Very Low', action: 'veryLow', color: '#AD1C3F' },
                { label: 'Low', action: 'low', color: '#D1A918' },
                { label: 'MinMax', action: 'minMax', color: '#2A750F' },
                { label: 'High', action: 'high', color: '#D1A918' },
                { label: 'Very High', action: 'veryHigh', color: '#AD1C3F' },
            ];
        },
        analysisType() {
            return this.analysisTypeId;
        },
        actionsLength() {
            return this.data[this.analysisType].actions.length;
        },
        displayActions() {
            return this?.actions?.map(({ id, name }) => ({
                id,
                name: name[this.userLang] || name[this.teamMainLang],
            }));
        },
        displayCorrectiveProcedures() {
            return this.correctiveProcedures.map(({ id, name }) => ({
                id,
                name: name[this.userLang] || name[this.teamMainLang],
            }));
        },
        displayAnalyticProcedures() {
            return this.analyticProcedures.map(({ id, name }) => ({
                id,
                name: name[this.userLang] || name[this.teamMainLang],
            }));
        },
    },
    watch: {
        chart: {
            handler() {
                this.data[this.analysisTypeId] = this.chart;
            },
            immediate: true,
        },
    },

    async created() {
        this.getChartAction();
        this.data[this.analysisTypeId] = this.chart;
    },
    methods: {
        async getChartAction() {
            const { data } = await this.$rq.getChartsAction({ pagination: false, analysisType: this.analysis.analysisType.id });
            this.actions = data.charts;
        },
        updateData() {
            this.$emit('sendData', { newData: this.data[this.analysisTypeId], analysisTypeId: this.analysisTypeId });
        },
        addRow() {
            this.data[this.analysisTypeId].actions.push({ chartAction: null, correctiveProcedure: null, norms: {} });
        },
        removeRow(index) {
            this.data[this.analysisTypeId].actions.splice(index, 1);
            this.updateData();
        },
        isNormDisabled(index, norms) {
            switch (index) {
                case 0:
                case 4:
                    return norms.low || norms.high;
                case 1:
                case 3:
                    return norms.veryHigh || norms.veryLow;
                default:
                    return false;
            }
        },
    },
});
</script>
